import { API_VERSIONS, asinzenAdminApi } from "client/api";

export const getCatalogItem = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/sp-api/get-catalog-item`, params)

export const getItemOffers = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/sp-api/get-item-offers`, params)

export const getMyFeesEstimateForAsin = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/sp-api/get-my-fees-est-asin`, params)

export const getMyFeesEstimates = (params: any) =>
  asinzenAdminApi({
    headers: {
      "content-type": "application/json",
    }
  })
    .post(`/${API_VERSIONS}/admin/users/sp-api/get-my-fees-ests`, params)